// Copyright (C) 2021 TANNER AG

import React from "react";
import { ArrowRight } from "../components/Icons";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
    link: {
        fontSize: 15,
        fontWeight: "bold",
        fontFamily: "Arial, sans-serif",
        textDecoration: "none",
        color: "#303C49",
        display: "flex",
        alignItems: "center",
        marginBottom: 12,
    },
    number: {
        color: "#e40045",
        marginRight: 8,
    },
});

const ActionLink = ({ children, to, number, classes, href }) => {
    if (href) {
        return (
            <a href={href} className={classes.link}>
                <ArrowRight size={12} style={{ color: "#e40045", marginRight: 8 }} />
                {number && <span className={classes.number}>{number}</span>}
                <span>{children}</span>
            </a>
        );
    }

    return (
        <Link to={to} className={classes.link}>
            <ArrowRight size={12} style={{ color: "#e40045", marginRight: 8 }} />
            {number && <span className={classes.number}>{number}</span>}
            <span>{children}</span>
        </Link>
    );
};

export default withStyles(styles)(ActionLink);



// WEBPACK FOOTER //
// ./src/emobility/ActionLink.js